import styles from './RoboticsKits.module.css';
import playdynamics from "../../../assets/images/online/robotics/dynamics.jpg";
import triangle from "../../../assets/images/online/robotics/triangle.jpg";
import bike from "../../../assets/images/online/robotics/bike.jpg";
import scissorlift from "../../../assets/images/online/robotics/scissor.jpg";
import tanker from "../../../assets/images/online/robotics/tanker.jpg";
import ArduinoImage from "../../../assets/images/online/robotics/Arduino.jpg";
import AutomaticRopeWalkerImage from "../../../assets/images/online/robotics/Automatic Rope Walker.jpg";
import BaseBotImage from "../../../assets/images/online/robotics/BaseBot.jpg";
import electronicsIOTImage from "../../../assets/images/online/robotics/electronicsIOT.jpg";
import opticImage from "../../../assets/images/online/robotics/optic.jpg";
import peeceeImage from "../../../assets/images/online/robotics/peecee.jpg";

const RoboticsKits = () => {
  const kits = [
    {
      title: "LEGO ROBOTICS - Playdynamics (Grade 1-2)",
      features: [
        "Basic mechanical principles, such as gears",
        "levers, pulleys, wheels, and axles",
        "Investigating force, buoyancy, and balance - Problem-solving through design",
        "Collaboration and data sharing"
      ],
      introImages: [playdynamics],
      projects: [
        { name: "LEGO Bike", image: bike },
        { name: "Scissor Lift", image: scissorlift },
        { name: "Triangle Shape", image: triangle },
        { name: "Military Tanker", image: tanker }
      ]
    },
    {
      title: "LEGO ROBOTICS - Playdynamics & Peecee (Grade 3-10)",
      features: [
        "Main topics - programming, control, interaction of hardware and software",
        "Use of actuators and sensors",
        "Engaging students in science by making it real and relevant",
        "Basic programming skills, critical thinking, and problem-solving",
        "Collaboration and presentation skills"
      ],
      introImages: [playdynamics, peeceeImage],
      projects: [
        { name: "Base Bot", image: BaseBotImage },
        { name: "Automatic Rope walker", image: AutomaticRopeWalkerImage }
      ]
    },
    {
      title: "Electronics & IOT Kit (Grade 3-12)",
      features: [
        "Learn to create circuits and use resistors",
        "Introduction to Ohm's law and electronics",
        "Build smart devices with Arduino",
        "Hands-on experience with sensors and actuators"
      ],
      introImages: [electronicsIOTImage],
      projects: [
        { name: "Arduino Programming Kit", image: ArduinoImage },
        { name: "Optical Sensor Kit", image: opticImage }
      ]
    }
  ];

  return (
    <section className={styles.roboticsKits}>
      <div className={styles.container}>
        <h2 className={styles.title}>ROBOTICS & AI with KIT</h2>
        
        <div className={styles.kitsContainer}>
          {kits.map((kit, index) => (
            <div key={index} className={styles.kitCard}>
              <h3>{kit.title}</h3>
              
              <div className={styles.featuresAndImage}>
                {kit.introImages && kit.introImages.length > 0 && (
                  <div className={styles.introImagesWrapper}>
                    {kit.introImages.map((imageSrc, idx) => (
                      <img key={idx} src={imageSrc} alt="" className={styles.introImage} />
                    ))}
                  </div>
                )}
                {kit.features && (
                  <ul className={styles.features}>
                    {kit.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                )}
              </div>

              {kit.description && (
                <p className={styles.description}>{kit.description}</p>
              )}

              {kit.projects && (
                <div className={styles.projects}>
                  {kit.projects.map((project, idx) => (
                    <div key={idx} className={styles.project}>
                      <img src={project.image} alt="" />
                      <p>{project.name}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoboticsKits; 